/**
 * Created by filatov on 08.09.2015.
 */
import $ from "jquery"
import {ReportGroupingLevel} from './constants'
import {escapeHtmlSymbols} from '../atUtils'
import messageResource from '../messageResource'

export default function InvoicePreviewRenderer(){}

InvoicePreviewRenderer.prototype.init = function(){
    this.itemsTable = $("#itemsTable");
    return this;
};

InvoicePreviewRenderer.prototype.updateGrouping = function(reportParameters){

    this.itemsTable.find("tbody.itemsBody").empty();
    let levels = []
    if (reportParameters.firstGroupingLevel !==  ReportGroupingLevel.NONE){
        levels.push(reportParameters.firstGroupingLevel);
    }
    if (reportParameters.secondGroupingLevel !== ReportGroupingLevel.NONE){
        levels.push(reportParameters.secondGroupingLevel);
    }
    if (reportParameters.thirdGroupingLevel !== ReportGroupingLevel.NONE){
        this._addLevelsDependsFromThirdLevel(levels, reportParameters.thirdGroupingLevel);
    }

    const allUsersAvailable = reportParameters.reportAuthorizationInfo.allUsersAvailable

    const $template = $("#itemsTable").find("tbody.template")
    const $templateRow = $template.find("tr.templateRow").clone()
    levels.length > 0 ? $templateRow.find(".firstLayer").html(this._getEscapedLevelPreviewName(levels[0])) : $templateRow.find(".firstLayer").hide()
    levels.length > 1 ? $templateRow.find(".secondLayer").html(" - " + this._getEscapedLevelPreviewName(levels[1])) : $templateRow.find(".secondLayer").hide()
    levels.length > 2 ? $templateRow.find(".thirdLayer").html(" - " + this._getEscapedLevelPreviewName(levels[2])) : $templateRow.find(".thirdLayer").hide()
    levels.length > 3 ? $templateRow.find(".fourthLayer").html(" - " + this._getEscapedLevelPreviewName(levels[3])) : $templateRow.find(".fourthLayer").hide()

    if (levels.length === 1) {
        let isUserLevel = levels[0] === ReportGroupingLevel.USER
        this._cloneRow($templateRow, 4)
        if (isUserLevel && !allUsersAvailable) {
            $('.itemsBody .firstLayer').last().text(this._getOthersLevelName())
        }
    } else if (levels.length === 2) {
        this._cloneRow($templateRow, 3)
        if (levels[0] === ReportGroupingLevel.USER && !allUsersAvailable) {
            $('.itemsBody .firstInRow').append('<div class="firstLayer">' + this._getOthersLevelName() + '</div>')
        } else if (levels[1] === ReportGroupingLevel.USER && !allUsersAvailable) {
            $('.itemsBody .firstInRow').append('<div class="secondLayer">' + ' - ' + this._getOthersLevelName() + '</div>')
        }

    } else if (levels.length > 2) {
        this._cloneRow($templateRow, 2)
        if (levels[0] === ReportGroupingLevel.USER && !allUsersAvailable) {
            $('.itemsBody .firstInRow').append('<div class="firstLayer">' + this._getOthersLevelName() + '</div>')
            if (levels[1] !== ReportGroupingLevel.TT_COMMENTS)
                $('.itemsBody .firstInRow').append('<div class="secondLayer">' + ' - ' + this._getEscapedLevelPreviewName(levels[1]) + '</div>')
            if (levels[2] !== ReportGroupingLevel.TT_COMMENTS)
                $('.itemsBody .firstInRow').append('<div class="thirdLayer">' + ' - ' + this._getEscapedLevelPreviewName(levels[2]) + '</div>')

        } else if (levels[1] === ReportGroupingLevel.USER && !allUsersAvailable) {
            $('.itemsBody .firstInRow').append('<div class="secondLayer">' + ' - ' + this._getOthersLevelName() + '</div>')
            if (levels[2] !== ReportGroupingLevel.TT_COMMENTS)
                $('.itemsBody .firstInRow').append('<div class="thirdLayer">' + ' - ' + this._getEscapedLevelPreviewName(levels[2]) + '</div>')
        }
    }
};

InvoicePreviewRenderer.prototype._getOthersLevelName = function() {
    return messageResource.getMessage("report.other_users")
}

InvoicePreviewRenderer.prototype._cloneRow = function($templateRow, numberOfClones) {
    for(let  i = 0; i < numberOfClones; i++){
        const $row = $templateRow.clone();
        this.itemsTable.find(".itemsBody").append($row);
    }
}

InvoicePreviewRenderer.prototype._addLevelsDependsFromThirdLevel = function( levels, thirdGroupingLevel) {
    switch ( thirdGroupingLevel ){
        case ReportGroupingLevel.TASK_AND_TT_COMMENTS:
            levels.push( ReportGroupingLevel.TASK);
            levels.push( ReportGroupingLevel.TT_COMMENTS );
            break;
        case ReportGroupingLevel.PROJECT_AND_TT_COMMENTS:
            levels.push( ReportGroupingLevel.PROJECT );
            levels.push( ReportGroupingLevel.TT_COMMENTS );
            break;
        case ReportGroupingLevel.CUSTOMER_AND_TT_COMMENTS:
            levels.push( ReportGroupingLevel.CUSTOMER );
            levels.push( ReportGroupingLevel.TT_COMMENTS );
            break;
        default:
            levels.push( thirdGroupingLevel );
    }
};

InvoicePreviewRenderer.prototype.getName = function(groupingLevelValue){
   switch (groupingLevelValue){
       case ReportGroupingLevel.CUSTOMER : return "customer";
       default :return "otherGrouping";
   }
};

InvoicePreviewRenderer.prototype._getEscapedLevelPreviewName = function( level ) {
    return escapeHtmlSymbols( ReportPreviewUtils.getLevelPreviewName( level ));
};


// WEBPACK FOOTER //
// ./web/js/reports/InvoicePreviewRenderer.js